import * as Sentry from '@sentry/react';
import { ENV } from '../../environment';
import { config } from './config';

let hasInitialized = false;
export default (() => {
  if (ENV === 'development') return;
  if (!hasInitialized) {
    Sentry.init({
      debug: ENV === 'staging',
      dsn: config.dsn,
      environment: ENV,
      integrations: [new Sentry.Replay()],
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: 0,
    });
    hasInitialized = true;
  }
  return Sentry;
})();
